import { Box, getColor, Typography } from "fds";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import utilsCommon from "../../shared/utils/common";
import {
  TopDocWorkgroupDto,
  TopMemberWorkgroupDto,
} from "../../types/adminHome";
import useAdminHomeStore from "../../redux/dispatcher/useAdminHomeStore";

const HomeBottom = () => {
  const { t } = useTranslation();

  const [topMemberWorkgroups, setTopMemberWorkgroups] = useState(
    [] as TopMemberWorkgroupDto[]
  );
  const [topDocWorkgroups, setTopDocWorkgroups] = useState(
    [] as TopDocWorkgroupDto[]
  );

  const { adminHomeStore, getTopMemberWorkgroup, getTopDoc } =
    useAdminHomeStore();

  useEffect(() => {
    getTopMemberWorkgroup();
    getTopDoc();
  }, []);

  useEffect(() => {
    setTopMemberWorkgroups(adminHomeStore.topMemberWorkgroup);
    setTopDocWorkgroups(adminHomeStore.topDocWorkgroup);
  }, [adminHomeStore]);

  return (
    <Box classes="adminHome_bottom">
      <Box classes="adminHome_bottom-rank" direction="column">
        <Typography
          type="body2_rg"
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
          classes="adminHome_bottom-rank--title"
        >
          {t("admin.home.userWorkgroupTop")}
        </Typography>
        <table>
          <colgroup>
            <col style={{ width: "5%" }}></col>
            <col style={{ width: "60%" }}></col>
            <col style={{ width: "15%" }}></col>
            <col style={{ width: "20%" }}></col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>{t("admin.home.workGroupName")}</th>
              <th>{t("admin.home.member")}</th>
              <th>{t("admin.home.creationDate")}</th>
            </tr>
          </thead>
          <tbody>
            {topMemberWorkgroups
              .filter((item, index) => index < 5)
              .map((item, index) => (
                <tr key={index}>
                  <td>
                    <Typography exactColor={getColor("COLOR_TEXT_BRAND")}>
                      {index + 1}
                    </Typography>
                  </td>
                  <td>{item.workgroupName}</td>
                  <td>{item.memberCount}</td>
                  <td>{utilsCommon.getDateStr(item.createDate)}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
      <Box classes="adminHome_bottom-rank" direction="column">
        <Typography
          type="body2_rg"
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
          classes="adminHome_bottom-rank--title"
        >
          {t("admin.home.sharedFileWorkgroupTop")}
        </Typography>
        <table>
          <colgroup>
            <col style={{ width: "5%" }}></col>
            <col style={{ width: "60%" }}></col>
            <col style={{ width: "15%" }}></col>
            <col style={{ width: "20%" }}></col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>{t("admin.home.workGroupName")}</th>
              <th>{t("admin.home.shareFile")}</th>
              <th>{t("admin.home.creationDate")}</th>
            </tr>
          </thead>
          <tbody>
            {topDocWorkgroups
              .filter((item, index) => index < 5)
              .map((item, index) => (
                <tr key={index}>
                  <td>
                    <Typography exactColor={getColor("COLOR_TEXT_BRAND")}>
                      {index + 1}
                    </Typography>
                  </td>
                  <td>{item.workgroupName}</td>
                  <td>{item.count}</td>
                  <td>{utilsCommon.getDateStr(item.regDate)}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
};
export default HomeBottom;
